import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'
import { LK_MUN_MEH_FORM_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: ':munMehId/form',
    name: ROUTES.LAYOUT,
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "mun-meh-lk-form.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewLKMunMehFormLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: 'indicators/:levels(.*)',
        name: ROUTES.ANY_LEVEL,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.view.third" */
          './LKMunMehFormView.vue'
        ),
      },
      {
        path: '/',
        name: ROUTES.FORM,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.view" */
          './LKMunMehFormView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
